/**
 * Created by Viacheslav Stepanian on 20.07.2026
 */

OrderIcon.prototype.ctor = cleverapps.extendFunc(OrderIcon.prototype.ctor, function (maker, orders) {
    this._super(maker, orders);

    if (maker.unit.findComponent(HungryGamesCustomer)) {
        this.background.setSpriteFrame(bundles.ordericon.frames.order_sheet_hungry);
    }
});

OrderIcon.prototype.updateSelection = cleverapps.extendFunc(OrderIcon.prototype.updateSelection, function (maker) {
    this._super(maker);

    if (this.maker.unit.findComponent(HungryGamesCustomer)) {
        this.background.setSpriteFrame(bundles.ordericon.frames.order_sheet_hungry);
    }
});
